export const EMPTY_VALUE = ' (empty value) ';

export enum OfferedReportStatusText {
    SUCCESS = 'Successfull',
    ERROR = 'Error',
    UNDEFINED = 'Undefined',
}
